export const EDITOR_MAX_TABS = 5;
export const EDITOR_MAX_TABS_EXPLANATION = `You can only open up to ${EDITOR_MAX_TABS} result tabs at the same time due to memory limitation.`;
